module.exports = __webpack_public_path__ + "img/img (14).078909f0.jpg";